import React from "react";
import HomeImage from "../image/homeImage.jfif";
import { useNavigate } from "react-router-dom";
import { HomeHeader } from "../components/HomeHeader";
import { HomeHeaderTwo } from "../components/HomeHeaderTwo";

const Home = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <HomeHeader />
    </React.Fragment>
  );
};

export default Home;
